"use strict";
exports.doNotTrack = [true, 'yes', '1'].indexOf(navigator.doNotTrack || navigator.msDoNotTrack || window.doNotTrack);
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = exports.doNotTrack;



/*****************
 ** WEBPACK FOOTER
 ** ./~/coveo.analytics/dist/donottrack.js
 ** module id = 92
 ** module chunks = 0 1
 **/